import { render, staticRenderFns } from "./Availability.vue?vue&type=template&id=15fc8145&scoped=true&"
import script from "./Availability.vue?vue&type=script&lang=js&"
export * from "./Availability.vue?vue&type=script&lang=js&"
import style0 from "./Availability.vue?vue&type=style&index=0&id=15fc8145&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fc8145",
  null
  
)

export default component.exports